// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._16jlkb7n{flex-grow:1}
._19pkx0bf{margin-top:var(--ds-space-negative-100,-8px)}
._1o9zkb7n{flex-shrink:1}
._i0dlf1ug{flex-basis:0%}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/renderer/node_modules/@atlaskit/link-datasource/dist/esm/ui/assets-modal/search-container/object-schema-select/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,WAAW;AACtB,WAAW,4CAA4C;AACvD,WAAW,aAAa;AACxB,WAAW,aAAa","sourcesContent":["._16jlkb7n{flex-grow:1}\n._19pkx0bf{margin-top:var(--ds-space-negative-100,-8px)}\n._1o9zkb7n{flex-shrink:1}\n._i0dlf1ug{flex-basis:0%}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
